module.exports = __webpack_public_path__ + "static/media/YF49_2.e75fff0b.jpg";